import { Link } from 'react-router-dom';

const cards = [
  {
    title: 'Развитие управленческих компетенций',
    desc: 'Как системно развивать навыки руководителей и определять зоны роста.',
    href: '/menedzhment-i-liderstvo/razvitie-upravlencheskih-kompetenciy',
  },
  {
    title: 'Делегирование и постановка задач',
    desc: 'Как передавать сотрудникам задачи и ответственность.',
    href: '/menedzhment-i-liderstvo/delegirovanie-i-postanovka-zadach',
  },
  {
    title: 'Обратная связь и сложные разговоры',
    desc: 'Как помогать сотрудникам менять поведение и развиваться.',
    href: '/menedzhment-i-liderstvo/obratnaya-svyaz-i-slozhnye-razgovory',
  },
  {
    title: 'Мотивация и управление командой',
    desc: 'Как создавать условия для самостоятельной и результативной работы.',
    href: '/menedzhment-i-liderstvo/motivatsiya-i-upravlenie-komandoy',
  },
  {
    title: 'Тренинг по лидерству',
    desc: 'Как развивать влияние и лидерские навыки руководителей.',
    href: '/menedzhment-i-liderstvo/trening-po-liderstvu',
  },
];

export default function ReadNextSection() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Что изучить дальше
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Наставничество тесно связано с другими направлениями развития руководителей и управленческих команд кластера «Менеджмент и лидерство»
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-5xl mx-auto">
          {cards.map((card) => (
            <Link
              key={card.href + card.title}
              to={card.href}
              className="bg-gray-50 rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors group cursor-pointer"
            >
              <h3 className="font-bold text-gray-900 text-sm mb-2 group-hover:text-teal-600 transition-colors">{card.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed mb-3">{card.desc}</p>
              <span className="inline-flex items-center gap-1 text-xs font-semibold text-teal-600">
                Подробнее
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}